/**
 * Normalize API failures into a field → string[] map for form UIs.
 * Supports Laravel-style { data: { errors } }, Zod { error: [{field,message}] },
 * and the app contract { success:false, message, error }.
 */
export function formErrorsFromApi(error: any, fallbackField = 'email'): Record<string, string[]> {
    if (!error) {
        return {[fallbackField]: ['Something went wrong. Please try again.']};
    }

    if (error?.data?.errors && typeof error.data.errors === 'object') {
        return error.data.errors;
    }

    if (error?.errors && typeof error.errors === 'object' && !Array.isArray(error.errors)) {
        return error.errors;
    }

    if (Array.isArray(error?.error)) {
        const map: Record<string, string[]> = {};
        for (const item of error.error) {
            const field = item?.field || fallbackField;
            const message = item?.message || 'Invalid value';
            if (!map[field]) map[field] = [];
            map[field].push(message);
        }
        return Object.keys(map).length ? map : {[fallbackField]: ['Validation failed']};
    }

    const message =
        (typeof error.message === 'string' && error.message)
        || (typeof error.error === 'string' && error.error)
        || null;

    if (message && message !== 'Network error') {
        const field = /password/i.test(message) ? 'password' : fallbackField;
        return {[field]: [message]};
    }

    if (error?.status === 0 || message === 'Network error') {
        return {[fallbackField]: ['Unable to reach the server. Please try again.']};
    }

    return {[fallbackField]: [message || 'Something went wrong. Please try again.']};
}
